<template>
  <div class='drawer-wrapper'>
    <el-drawer :wrapperClosable="true" :title="title" :visible.sync="editFlag" size="50%" :before-close="AddNone">
      <div class="demo-drawer__content">
        <el-form :model="addFrom" size="medium" label-width="100px" class="mt35" :rules="rules" ref="ruleForm">

          <!--        <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="11" class="mb20">-->
          <el-form-item label="标题" prop="name" style="width: 90%">
            <el-input v-model="addFrom.name" placeholder="请输入标题" clearable></el-input>
          </el-form-item>
          <!--        </el-col>-->

          <!--        <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="11" class="mb20">-->
          <el-form-item label="内容" prop="content" style="width: 90%">
            <quill-editor ref="myQuillEditor" v-model="addFrom.content" :options="editorOption"/>
            <!--            <el-input v-model="addFrom.content" type="textarea" autosize placeholder="请输入内容" clearable></el-input>-->
          </el-form-item>
          <!--        </el-col>-->

          <!--        <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="15" class="mb20">-->
          <el-form-item label="状态" style="width: 90%">
            <el-radio-group v-model="addFrom.status">
              <el-radio :label="1">正常</el-radio>
              <el-radio :label="0">隐藏</el-radio>
            </el-radio-group>
          </el-form-item>
          <!--        </el-col>-->

        </el-form>
      </div>

      <div class="demo-drawer__footer">
        <el-button @click="AddNone">取 消</el-button>
        <el-button type="primary" @click="addPush">确 定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>

import {agreementsApi} from "@/api/SystemConfig/agreements";
import {quillEditor} from "vue-quill-editor";
import {processErrors} from "@/utils/errorHandler";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

export default {
  props: ['editFlag', "editID"],
  components: {
    quillEditor,
  },
  data() {
    return {
      title: "新增",
      dataList: [],
      dataListCache: [],
      editorOption: {
        theme: "snow", // 默认主题
        placeholder: "请在这里输入", // 默认输入内容
      },
      addFrom: {
        id: '',
        name: '',
        content: '',
        status: 1,
      }
      , rules: {

        name: [
          {required: true, message: '请输入名称', trigger: 'blur'},
        ],

      },
      appidList: [],
      EditFlag: false,
      isInputDisabled: true,
      radioFlag: true,
      flagTab: false
    };
  },
  created() {
    this.getInfo()
  },

  methods: {
    getInfo() {
      let params = {
        id: this.editID
      }
      let api = agreementsApi()
      api.getAgreementsInfo(params).then(res => {
        if (res.code == 0) {
          this.EditFlag = true
          this.title = "编辑"
          this.addFrom = {
            id: res.data.id,
            name: res.data.name,
            content: res.data.content,
            status: res.data.status,
          }
        } else {
          processErrors(res);
        }
      })
    },

    reset() {
      this.addFrom = {}
    },
    AddNone() {
      this.addFrom = {}
      this.title = ""
      this.$refs['ruleForm'].resetFields();
      this.$emit('NoneeditFlag');
    },
    addPush() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let api = agreementsApi()

          api.edit(this.addFrom).then(res => {
            if (res.code == 0) {
              this.$message({
                message: '创建成功',
                type: 'success'
              });
              this.$emit('Editok');
            } else {
              processErrors(res);
            }

          })
        } else {
          return false;
        }
      });

    }
  },

  mounted() {

  },
}
</script>
<style lang='scss' scoped>
.demo-drawer__content {
  height: calc(100% - 80px); /* 给内容区域设置高度,留出按钮区域 */
  overflow-y: auto; /* 添加垂直滚动条 */
  overflow-x: hidden;
}

.form-wrapper {
  padding-bottom: 80px; /* 给表单内容添加底部间距,留出按钮区域 */
}

.demo-drawer__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  text-align: center;
}

.demo-drawer__footer .el-button {
  margin: 0 10px;
  width: calc(50% - 20px);
}

::v-deep .el-drawer__close-btn{
  font-size: 30px;
  font-weight: bold;
}
</style>
